document.addEventListener("DOMContentLoaded", () => {
  const kanjis = document.querySelectorAll(".kanji");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {

        // 親のfv-copyが入ったら全部発火
        kanjis.forEach(el => el.classList.add("active"));

        observer.disconnect(); // 1回だけ
      }
    });
  }, {
    threshold: 0.4
  });

  observer.observe(document.querySelector(".fv-copy"));
});



    window.addEventListener("load", function() {
        const ENABLE_FV_ANIMATION = true; // true: 有効 / false: 無効

        const chars = gsap.utils.toArray(".kanji .char");
        const copy = document.querySelector(".fv-kanjibox");
        const reveal = document.querySelector(".js-main-reveal");
        const textSpans = document.querySelectorAll(
            ".fv-copy-text span:not(.space)",
        );

        const finishFV = () => {
            document.body.classList.remove("is-loading");
            document.body.classList.add("is-loaded");

            if (copy) copy.style.display = "none";

            gsap.set(reveal, {
                clearProps: "clipPath",
            });
            gsap.set(textSpans, {
                opacity: 1,
                filter: "blur(0px)",
            });

            window.dispatchEvent(new Event("fvAnimationDone"));
        };

        if (!ENABLE_FV_ANIMATION) {
            sessionStorage.removeItem("fvAnimationPlayed");
            finishFV();
            return;
        }

        const alreadyPlayed =
            sessionStorage.getItem("fvAnimationPlayed") === "1";

        if (alreadyPlayed) {
            finishFV();
            return;
        }

        document.body.classList.add("is-loading");

        const getCircle = (radius) => {
            const x = window.innerWidth / 2;
            const y = window.innerHeight / 2;
            return `circle(${radius}px at ${x}px ${y}px)`;
        };

        const endRadius = Math.hypot(window.innerWidth, window.innerHeight);

        gsap.set(reveal, {
            clipPath: getCircle(0),
        });
        gsap.set(textSpans, {
            opacity: 0,
            filter: "blur(8px)",
        });

        const tl = gsap.timeline();

        tl.fromTo(
            chars, {
                scale: 1.6,
                opacity: 0,
                filter: "blur(6px)",
            }, {
                scale: 1,
                opacity: 1,
                filter: "blur(0px)",
                duration: 1,
                ease: "expo.out",
                stagger: {
                    each: 0.4,
                },
            },
        );

        tl.to({}, {
            duration: 0.35,
        }, );

        tl.to(copy, {
            opacity: 0,
            duration: 0.45,
            ease: "power2.out",
        });

        tl.to(
            reveal, {
                clipPath: getCircle(endRadius),
                duration: 1.1,
                ease: "power3.inOut",
            },
            "-=0.15",
        );

        tl.set(copy, {
            display: "none",
        });

        tl.fromTo(
            textSpans, {
                opacity: 0,
                filter: "blur(8px)",
            }, {
                opacity: 1,
                filter: "blur(0px)",
                duration: 0.45,
                ease: "power2.out",
                stagger: {
                    each: 0.03,
                },
            },
            "-=0.1",
        );

        tl.call(() => {
            textSpans.forEach((span, i) => {
                setTimeout(() => {
                    span.classList.add("is-glow");
                    setTimeout(() => span.classList.remove("is-glow"), 450);
                }, i * 25);
            });
        });

        tl.to({}, {
            duration: textSpans.length * 0.025 + 0.45,
        }, );

        tl.call(() => {
            sessionStorage.setItem("fvAnimationPlayed", "1");
            finishFV();
        });
    });
    /*       gsap.utils.toArray(".parallax_content").forEach((section) => {
        const bg = section.querySelector(".parallax_bg");
        gsap.utils.toArray(".parallax_content").forEach((section) => {
          const bg = section.querySelector(".parallax_bg");

          gsap.fromTo(
            bg,
            { y: -150 },
            {
              y: 150,
              scrub: true,
              ease: "none",
              scrollTrigger: {
                trigger: section,
                start: "top bottom",
                end: "bottom top",
              },
            },
          );
        });
      }); */

    document.addEventListener("DOMContentLoaded", () => {
        const initTyping = () => {
            const targets = document.querySelectorAll(".type-copy");

            targets.forEach((target) => {
                const chars = target.querySelectorAll("span");

                const cursor = document.createElement("i");
                cursor.className = "type-cursor";

                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (!entry.isIntersecting) return;

                            target.insertBefore(cursor, chars[0]);

                            let delay = 0;

                            chars.forEach((char) => {
                                const text = char.textContent;

                                delay += 120 + Math.random() * 60;

                                if (text === "。" || text === "、") {
                                    delay += 140;
                                }

                                setTimeout(() => {
                                    char.classList.add("show");

                                    char.after(cursor);
                                }, delay);
                            });

                            observer.disconnect();
                        });
                    }, {
                        threshold: 0.5,
                    },
                );

                observer.observe(target);
            });
        };

        // FVアニメ完了後にタイピング開始
        window.addEventListener("fvAnimationDone", initTyping, {
            once: true,
        });
    });

